export const replaceVariables = (str: string, data: Record<string, string>) => {
  if (!Object.keys(data).length) {
    return str;
  }

  let result;
  while ((result = variableRegex.exec(str)) !== null) {
    str = str.replaceAll(`{${result[1]}}`, data[result[1]]);
  }

  return str;
};

const variableRegex = /{(.*?)}/gim;
